import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {Modal, Dialogue} from '@albert-io/atomic';

import ConfirmSchoolScreen from './ConfirmSchoolScreen.react';
import SchoolSearchInputs from './SchoolSearchInputs.react';

import './school-lookup-modal.scss';

const SchoolSearchModal = ({handleClose, hasExistingRecord, updateUserSchool, isTeacher}) => {
  const [step, setStep] = useState(0);

  const [selectedSchool, setSelectedSchool] = useState(undefined);

  const handleNextStep = () => {
    if (isTeacher) {
      setStep((prevStep) => prevStep + 1);
    } else {
      updateUserSchool(selectedSchool);
      handleClose();
    }
  };

  return (
    <Modal ariaLabel='Change your school association.' handleClose={handleClose}>
      {({modalContentStyle}) => {
        return (
          <Dialogue
            inModal
            className={`${modalContentStyle} school-lookup-modal__container`}
            handleClose={handleClose}
            title={step === 0 ? 'School lookup' : undefined}
            size={step === 0 ? 'l' : 'm'}
            paddingLevel={step === 0 ? 3 : 4}
            hideCloseBtn={step !== 0}
          >
            <Dialogue.Body>
              {step === 0 ? (
                <SchoolSearchInputs
                  selected={selectedSchool}
                  onClear={() => setSelectedSchool(undefined)}
                  setSelected={setSelectedSchool}
                  shouldShowHelpText={isTeacher}
                  onSubmit={handleNextStep}
                  hasExistingRecord={hasExistingRecord}
                />
              ) : (
                <ConfirmSchoolScreen
                  selectedSchool={selectedSchool}
                  confirmSchool={() => {
                    updateUserSchool(selectedSchool);
                    handleClose();
                  }}
                  goBack={() => setStep(step - 1)}
                />
              )}
            </Dialogue.Body>
          </Dialogue>
        );
      }}
    </Modal>
  );
};

SchoolSearchModal.propTypes = {
  handleClose: PropTypes.func,
  hasExistingRecord: PropTypes.func,
  updateUserSchool: PropTypes.func,
  isTeacher: PropTypes.bool
};

export default SchoolSearchModal;
